import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./services/Router";
import AppHomepage from "./AppHomepage";

const element_production = document.getElementById("gr_blog_list");
const element_production_homepage = document.getElementById("gr_blog_homepage");
const element_development = document.getElementById("root");

if (typeof element_production != "undefined" && element_production != null) {
  const root = ReactDOM.createRoot(element_production);
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

if (
  typeof element_production_homepage != "undefined" &&
  element_production_homepage != null
) {
  const root = ReactDOM.createRoot(element_production_homepage);
  root.render(
    <React.StrictMode>
      <AppHomepage />
    </React.StrictMode>
  );
}

if (typeof element_development != "undefined" && element_development != null) {
  const root = ReactDOM.createRoot(element_development);
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}
